import {
  Scene, 
  Engine, 
  Color4, 
  Color3,
  Vector3, 
  FreeCamera, 
  HemisphericLight, 
  DirectionalLight,
  MeshBuilder,
  PBRMaterial,
  Texture,
  SceneLoader,
  VideoTexture,
  GlowLayer,
  StandardMaterial,
  MirrorTexture,
  Plane,
  Animatable,
  VirtualJoysticksCamera,
  ActionManager,
  ExecuteCodeAction,
  Sound,
  AssetsManager,
  ScenePerformancePriority,
  } from "@babylonjs/core";
import "@babylonjs/loaders";
import { CustomLoading } from "./customLoading";
import { AdvancedDynamicTexture, Image } from "@babylonjs/gui";


export class WebBT {
  scene: Scene;
  engine: Engine;  
  loadingScreen: CustomLoading;
  camera!: VirtualJoysticksCamera;
  camera1!: FreeCamera;
  lowRad: number;
  upperRad: number;
  fovAnim!: Animatable;
  VirtualJoysticksCamera: any;
  FreeCamera: any;
  logoImageUp!: Image;

constructor(private canvas: HTMLCanvasElement, private loadContainer: HTMLElement, private loadAnim: HTMLElement,) {
    this.engine = new Engine(this.canvas, true, {
      antialias: true,
      // preserveDrawingBuffer: false,
    });
  this.engine.setHardwareScalingLevel(0.5);

  this.loadingScreen = new CustomLoading(this.loadContainer, this.loadAnim);

  this.engine.loadingScreen = this.loadingScreen;
  this.engine.displayLoadingUI();

  this.scene = this.CreateScene();
  this.lowRad = 0.3;
  this.upperRad = 2.5;
  // this.CreateEnvironment();
  // this.ChooseCamera();
  this.Mozila_iOS();
  this.iOS();

  this.engine.runRenderLoop(()=>{
      this.scene.render();
  });
  this.canvas.addEventListener("resize", () => { 
    this.engine.resize(); 
  });

  window.addEventListener("resize", () => {
    this.engine.resize();
  });
}
CreateScene(): Scene {
  const scene = new Scene(this.engine); 
  const assumedFramesPerSecond = 60;
  const earthGravity = -9.8;
  scene.gravity = new Vector3(0, earthGravity / assumedFramesPerSecond, 0);
  scene.clearColor = new Color4(0, 0, 0, 1);
  scene.collisionsEnabled = true;
  scene.enablePhysics();
  scene.performancePriority = ScenePerformancePriority.Intermediate;
  scene.pointerMovePredicate = () => false;
  scene.pointerDownPredicate = () => false;
  scene.pointerUpPredicate = () => false;
  scene.clearCachedVertexData();  
  return scene;
}
async Mozila_iOS(): Promise<void> {
  // const ua = navigator.userAgent;
if ((navigator.userAgent.indexOf("Firefox") === -1)) {
    // console.log("sdgvsdgv");
    this.CreateEnvironment();
    this.ChooseCamera();
    // this.CreateCamera1(); 
} 
else {
  // console.log("sdgvsdgv");
  this.Nothing();
  // this.CreateEnvironment();
  // this.PointCloud();
}
}
async iOS(): Promise<void> {
if(navigator.userAgent.match(/iPad|iPhone|iPod/i)) {
    // console.log("sdgvsdgv");
    this.NothingIOS();
    // this.CreateEnvironment();
    // this.PointCloud();
}
// else {
//   // console.log("sdgvsdgv");
//   this.Nothing();
//   // this.CreateEnvironment();
//   // this.PointCloud();
// }
}

async Nothing(): Promise<void> {
  alert("This experience is not supported by your browser");
  // this.scene.executeWhenReady(() => this.engine.hideLoadingUI()); 
}
async NothingIOS(): Promise<void> {
  alert("This experience is not yet supported by your device");
  // this.scene.executeWhenReady(() => this.engine.hideLoadingUI()); 
}
async ChooseCamera(): Promise<void> {

    const deviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    else if (/Mobile|Android|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
};

if (deviceType() === "desktop") {
  this.CreateCamera1();
}
if(deviceType() === "tablet" || deviceType() === "mobile"){
  this.CreateCamera();
}
}
async CreateCamera1(): Promise<void> {
  this.camera1 = new FreeCamera("freecamera", new Vector3(0, -0.5, 0), this.scene);
  this.camera1.attachControl(this.canvas, true);
  this.camera1.minZ = 0.25;
  this.camera1.speed = 0.3;
  this.camera1.applyGravity = true;
  this.camera1.ellipsoid = new Vector3(0.8, 1.2, 0.8);
  this.camera1.checkCollisions = true;
  this.camera1.onCollide;
  this.camera1.rotation = new Vector3(0, 0, 0);
  this.camera1.keysUp.push(87); // "w"
  this.camera1.keysDown.push(83); // "s"
  this.camera1.keysLeft.push(65); // "a"
  this.camera1.keysRight.push(68); // "d"  
}
async CreateCamera(): Promise<void> {
  this.camera = new VirtualJoysticksCamera("vrcamera", new Vector3(0, -0.5, 0), this.scene);
  this.camera.rotation = new Vector3(0, 0, 0);
  this.camera.attachControl(this.canvas, true);
  this.camera.minZ = 0.25;
  this.camera.speed = 0.1;
  this.camera.applyGravity = true;
  this.camera.ellipsoid = new Vector3(0.8, 1.2, 0.8);
  this.camera.checkCollisions = true;
  this.camera1.onCollide;
}
async CreateEnvironment(): Promise<void>{

  const model = await SceneLoader.ImportMeshAsync(
    "",
    "./assets/models/",
    "Binary.glb",        
    this.scene,
    (evt) => {
      const loadStatus = (evt.loaded * 100 / evt.total).toFixed();
      this.loadingScreen.updateLoadStatus(loadStatus);
    }
    );
  
  console.log(model.transformNodes, model.meshes);
  for(let i = 0; i < model.meshes.length; i++) {
    if(i != 1) model.meshes[i].checkCollisions = true;
  }
  model.meshes[1].freezeWorldMatrix();
  model.meshes[2].freezeWorldMatrix();
  model.meshes[3].freezeWorldMatrix();
  model.meshes[4].freezeWorldMatrix();
  model.meshes[5].freezeWorldMatrix();
  model.meshes[6].freezeWorldMatrix();
  model.meshes[7].freezeWorldMatrix();
  model.meshes[8].freezeWorldMatrix();
  model.meshes[9].freezeWorldMatrix();
  model.meshes[10].freezeWorldMatrix();
  model.meshes[11].freezeWorldMatrix();
  model.meshes[12].freezeWorldMatrix();
  model.meshes[13].freezeWorldMatrix();
  model.meshes[14].freezeWorldMatrix();
  model.meshes[15].freezeWorldMatrix();
  model.meshes[16].freezeWorldMatrix();
  model.meshes[17].freezeWorldMatrix();
  model.meshes[18].freezeWorldMatrix();
  model.meshes[19].freezeWorldMatrix();
  model.meshes[20].freezeWorldMatrix();
  model.meshes[21].freezeWorldMatrix();
  model.meshes[22].freezeWorldMatrix();
  model.meshes[23].freezeWorldMatrix();
  model.meshes[24].freezeWorldMatrix();
  model.meshes[25].freezeWorldMatrix();
  model.meshes[26].freezeWorldMatrix();
  model.meshes[27].freezeWorldMatrix();


  const dirLight = new DirectionalLight("dirLight", new Vector3(0,1,0), this.scene,)
  dirLight.diffuse = new Color3(1,1,1);
  dirLight.intensity = 1.5;
  const hemiLight = new HemisphericLight("hemiLight", new Vector3(0,1,0), this.scene);
  hemiLight.intensity = 1.8;
  hemiLight.diffuse = new Color3(1,1,1);

  const  glowLayer = new GlowLayer("glow", this.scene);
  glowLayer.intensity = 0.15;

  const assetsManager = new AssetsManager(this.scene);
  
  const music = new Sound("music", "./assets/models/BinaryTran.mp3", this.scene, function() {
    // music.isPlaying = true;
    music.autoplay = true;
    music.play();
    music.loop;
    music.setVolume(0.5);
  }
  );

  const displayMat1 = new PBRMaterial("displayMat1", this.scene);
  const displayTex1 = new VideoTexture(
    "displayTex1", 
    "./assets/models/Binary_Translation.mp4", 
    this.scene, 
    true,
    true, 
    VideoTexture.BILINEAR_SAMPLINGMODE, {
      autoUpdateTexture: true,
      autoPlay: false,
      loop: true
    });
  displayTex1.getAlphaFromRGB = true;
  displayMat1.alphaMode = Engine.ALPHA_ONEONE;
  displayMat1.opacityTexture = displayTex1;
  displayMat1.reflectanceTexture = displayTex1;
  displayMat1.reflectionColor = Color3.Black();
  displayMat1.backFaceCulling = false;
  displayMat1.metallic = 0;
  displayMat1.albedoColor = Color3.Black();
  displayMat1.emissiveColor = new Color3(1, 1, 1);
  displayMat1.emissiveIntensity = 1;
  displayMat1.emissiveTexture = displayTex1;    
  model.meshes[3].material = displayMat1;

  // const monik = new PBRMaterial("cubeMat11111", this.scene);
  // monik.alpha = 0;
  // monik.metallic = 0;
  // monik.roughness = 10;
  // model.meshes[3].material = monik;

  const spher = new StandardMaterial("cubeMat11111", this.scene);
  const diffuseTexspher = new Texture("./assets/textures/background.jpg",this.scene,false,false);
  spher.diffuseTexture = diffuseTexspher;  
  spher.specularColor = new Color3(0,0,0);
  model.meshes[5].material = spher;

  let cnt = 0;
  const collider = MeshBuilder.CreateBox("collider", {size: 3}, this.scene);

  const deviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    else if (/Mobile|Android|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
};

if (deviceType() === "desktop") {
  collider.parent = this.camera1;
}
if(deviceType() === "tablet" || deviceType() === "mobile"){
  collider.parent = this.camera;
}

  collider.actionManager = new ActionManager(this.scene);
  const action = new ExecuteCodeAction(
      {
          trigger: ActionManager.OnIntersectionEnterTrigger, 
          parameter: { 
              mesh:  model.meshes[4]
          }
      },
      () => {
        cnt+=1;
        if(cnt==1){
  
  music.setVolume(0, 1)

  const displayMat1 = new PBRMaterial("displayMat1", this.scene);
  const displayTex1 = new VideoTexture(
    "displayTex1", 
    "./assets/models/Binary_Translation.mp4", 
    this.scene, 
    true,
    true, 
    VideoTexture.BILINEAR_SAMPLINGMODE, {
      autoUpdateTexture: true,
      autoPlay: true,
      loop: true
    });
  displayTex1.getAlphaFromRGB = true;
  displayMat1.alphaMode = Engine.ALPHA_ONEONE;
  displayMat1.opacityTexture = displayTex1;
  displayMat1.reflectanceTexture = displayTex1;
  displayMat1.reflectionColor = Color3.Black();
  displayMat1.backFaceCulling = false;
  displayMat1.metallic = 0;
  displayMat1.albedoColor = Color3.Black();
  displayMat1.emissiveColor = new Color3(1, 1, 1);
  displayMat1.emissiveIntensity = 1;
  displayMat1.emissiveTexture = displayTex1;    
  model.meshes[3].material = displayMat1;
        }
      }
  );
  collider.actionManager.registerAction(action);

  const uvScale = 30;
  const texArray: Texture[] = [];

  const uvScalee = 7;
  const texArrayy: Texture[] = [];

  const uvScaleee = 60;
  const texArrayyy: Texture[] = [];

  const platform_floor = new StandardMaterial("cubeMat1", this.scene);
  const diffuseTexplatform_floor = new Texture("./assets/textures/platform_floor.jpg",this.scene,false,false);
  diffuseTexplatform_floor.getAlphaFromRGB = false;
  platform_floor.diffuseTexture = diffuseTexplatform_floor;
  platform_floor.roughness = 1;
  platform_floor.backFaceCulling = true;
  platform_floor.specularColor = new Color3(50/255,50/255,50/255);
  platform_floor.ambientTexture = diffuseTexplatform_floor;
  platform_floor.reflectionTexture = diffuseTexplatform_floor;
  platform_floor.useReflectionOverAlpha = true;
  const aoTexplatform_floor = new Texture("./assets/textures/beige_wall_001_ao_4k4.jpg", this.scene);
  platform_floor.ambientTexture = aoTexplatform_floor;
  texArrayy.push(aoTexplatform_floor);
  platform_floor.reflectionTexture = new MirrorTexture("mirror", {ratio: 1}, this.scene, true);
  (platform_floor.reflectionTexture as MirrorTexture).renderList = [model.meshes[3]];
  (platform_floor.reflectionTexture as MirrorTexture).mirrorPlane = new Plane(0, -1, 0, -3.6);
  (platform_floor.reflectionTexture as MirrorTexture).adaptiveBlurKernel = 128;
  (platform_floor.reflectionTexture as MirrorTexture).level = 0.5;
  model.meshes[1].material = platform_floor;

  const art1_glass = new PBRMaterial("cubeMat11", this.scene);
  const diffuseTexart1_glass  = new Texture("./assets/textures/background.jpg",this.scene,false,false);
  diffuseTexart1_glass.getAlphaFromRGB = true;
  diffuseTexart1_glass.uScale = -1;
  art1_glass.reflectionColor = Color3.White();
  art1_glass.backFaceCulling = false;
  art1_glass.opacityTexture = diffuseTexart1_glass;
  art1_glass.metallic = 0.1;
  art1_glass.albedoColor = Color3.Black();
  art1_glass.alpha = 0.5;
  art1_glass.alphaMode = Engine.ALPHA_ONEONE;
  art1_glass.reflectionTexture = new MirrorTexture("mirror",  {ratio: 1}, this.scene, true);
  (art1_glass.reflectionTexture as MirrorTexture).mirrorPlane =  new Plane(-1, 0, 0, -8);
  (art1_glass.reflectionTexture as MirrorTexture).renderList = [model.meshes[3],model.meshes[4],model.meshes[6],model.meshes[7],model.meshes[8],model.meshes[14],model.meshes[16],model.meshes[18],model.meshes[20],model.meshes[23],model.meshes[1]];
  model.meshes[19].material = art1_glass;
  model.meshes[15].material = art1_glass;

  const art2_glass = new PBRMaterial("cubeMat11", this.scene);
  const diffuseTexart2_glass  = new Texture("./assets/textures/background.jpg",this.scene,false,false);
  diffuseTexart2_glass.getAlphaFromRGB = true;
  diffuseTexart2_glass.uScale = -1;
  art2_glass.reflectionColor = Color3.White();
  art2_glass.backFaceCulling = false;
  art2_glass.opacityTexture = diffuseTexart2_glass;
  art2_glass.metallic = 0.1;
  art2_glass.albedoColor = Color3.Black();
  art2_glass.alpha = 0.5;
  art2_glass.alphaMode = Engine.ALPHA_ONEONE;
  art2_glass.reflectionTexture = new MirrorTexture("mirror",  {ratio: 1}, this.scene, true);
  (art2_glass.reflectionTexture as MirrorTexture).mirrorPlane =  new Plane(1, 0, 0, -8);
  (art2_glass.reflectionTexture as MirrorTexture).renderList = [model.meshes[3],model.meshes[4],model.meshes[6],model.meshes[7],model.meshes[8],model.meshes[14],model.meshes[16],model.meshes[18],model.meshes[20],model.meshes[23],model.meshes[1]];
  model.meshes[21].material = art2_glass;
  model.meshes[17].material = art2_glass;

  const room_floor = new StandardMaterial("cubeMat1", this.scene);
  const diffuseTexroom_floor = new Texture("./assets/textures/room_floor.jpg",this.scene,false,false);
  diffuseTexroom_floor.getAlphaFromRGB = false;
  room_floor.diffuseTexture = diffuseTexroom_floor;
  room_floor.roughness = 1;
  room_floor.backFaceCulling = true;
  room_floor.specularColor = new Color3(0,0,0);
  const aoTexroom_floor = new Texture("./assets/textures/beige_wall_001_ao_4k1.jpg", this.scene);
  room_floor.ambientTexture = aoTexroom_floor;
  texArrayy.push(aoTexroom_floor);
  model.meshes[7].material = room_floor;

  const platform = new StandardMaterial("cubeMat1", this.scene);
  const diffuseTexplatform = new Texture("./assets/textures/platform_out.jpg",this.scene,false,false);
  diffuseTexplatform.getAlphaFromRGB = false;
  platform.diffuseTexture = diffuseTexplatform;
  platform.roughness = 1;
  platform.backFaceCulling = true;
  platform.specularColor = new Color3(50/255,50/255,50/255);
  const aoTexplatform = new Texture("./assets/textures/beige_wall_001_ao_4k4.jpg", this.scene);
  platform.ambientTexture = aoTexplatform;
  texArrayy.push(aoTexplatform);
  model.meshes[2].material = platform;

  const wall = new StandardMaterial("cubeMat11", this.scene);
  const diffuseTexwall = new Texture("./assets/textures/room_in.jpg",this.scene,false,false);
  wall.diffuseTexture = diffuseTexwall;
  diffuseTexwall.getAlphaFromRGB = false;
  wall.specularColor = new Color3(0,0,0);
  const aoTexwall = new Texture("./assets/textures/beige_wall_001_ao_4k.jpg", this.scene);
  wall.ambientTexture = aoTexwall;
  texArray.push(aoTexwall);
  model.meshes[8].material = wall;  

  const wallOUT = new StandardMaterial("cubeMat11", this.scene);
  const diffuseTexwallOUT = new Texture("./assets/textures/wall_out.jpg",this.scene,false,false);
  wallOUT.diffuseTexture = diffuseTexwallOUT;
  diffuseTexwallOUT.getAlphaFromRGB = false;
  wallOUT.specularColor = new Color3(0,0,0);
  const aoTexwallOUT = new Texture("./assets/textures/beige_wall_001_ao_4k.jpg", this.scene);
  wallOUT.ambientTexture = aoTexwallOUT;
  texArray.push(aoTexwallOUT);
  model.meshes[9].material = wallOUT;  

  const pic1 = new StandardMaterial("cubeMat11", this.scene);
  const diffusepic1 = new Texture("./assets/textures/B.T BW Pic 1.jpg",this.scene,false,false);
  pic1.diffuseTexture = diffusepic1;
  pic1.diffuseTexture.hasAlpha = true;
  model.meshes[18].material = pic1;  

  const pic2 = new StandardMaterial("cubeMat11", this.scene);
  const diffusepic2 = new Texture("./assets/textures/B.T Red Pic 1.jpg",this.scene,false,false);
  pic2.diffuseTexture = diffusepic2;
  pic2.diffuseTexture.hasAlpha = true;
  model.meshes[20].material = pic2;  

  const sky = new StandardMaterial("cubeMat11", this.scene);
  const diffusesky = new Texture("./assets/textures/sky.jpg",this.scene,false,false);
  sky.diffuseTexture = diffusesky;
  sky.diffuseTexture.hasAlpha = true;
  sky.specularColor = new Color3(0,0,0);
  model.meshes[6].material = sky;  

  const text = new StandardMaterial("cubeMat11", this.scene);
  const diffuseTextext = new Texture("./assets/textures/inscription.png",this.scene,false,false);
  text.diffuseTexture = diffuseTextext;
  text.diffuseTexture.hasAlpha = true;
  text.alpha = 1;
  model.meshes[23].material = text;  
    
  texArray.forEach((tex) => {
    tex.uScale = uvScale;
    tex.vScale = uvScale;
  });

  texArrayy.forEach((tex) => {
    tex.uScale = uvScalee;
    tex.vScale = uvScalee;
  });

  texArrayyy.forEach((tex) => {
      tex.uScale = uvScaleee;
      tex.vScale = uvScaleee;
    });
  
  const glass = new PBRMaterial("cubeMat4", this.scene);
  glass.alpha = 0;
  glass.metallic = 0;
  glass.roughness = 10;
  model.meshes[22].material = glass;  
  model.meshes[24].material = glass;
  model.meshes[13].material = glass;

  this.scene.executeWhenReady(() => this.engine.hideLoadingUI());    
}
}